import { render, staticRenderFns } from "./Presets.vue?vue&type=template&id=fddf8fae&scoped=true&"
import script from "./Presets.vue?vue&type=script&lang=js&"
export * from "./Presets.vue?vue&type=script&lang=js&"
import style0 from "./Presets.vue?vue&type=style&index=0&id=fddf8fae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddf8fae",
  null
  
)

export default component.exports